module.exports = __webpack_public_path__ + "img/calendar-minus.7ecf5655.svg";